export default "__VITE_ASSET__COhyiSMJ__"